import type { ReactNode, SVGProps } from "react";

export function DocumentationIcon(props: SVGProps<SVGSVGElement>): ReactNode {
	return (
		<svg
			fill="none"
			height="12"
			viewBox="0 0 16 12"
			width="16"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M0.625 10.6249C1.68913 10.0689 2.89624 9.77612 4.125 9.77612C5.35376 9.77612 6.56087 10.0689 7.625 10.6249C8.68913 10.0689 9.89624 9.77612 11.125 9.77612C12.3538 9.77612 13.5609 10.0689 14.625 10.6249"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="1.25"
			/>
			<path
				d="M0.625 1.47379C1.68913 0.917737 2.89624 0.625 4.125 0.625C5.35376 0.625 6.56087 0.917737 7.625 1.47379C8.68913 0.917737 9.89624 0.625 11.125 0.625C12.3538 0.625 13.5609 0.917737 14.625 1.47379"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="1.25"
			/>
			<path
				d="M0.625 1.47388V10.6251"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="1.25"
			/>
			<path
				d="M7.625 1.47388V10.6251"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="1.25"
			/>
			<path
				d="M14.625 1.47388V10.6251"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="1.25"
			/>
		</svg>
	);
}
